import React from "react";
import LegalDocumentLayout from "./LegalDocumentLayout";

export default function TermsPage() {
  return (
    <LegalDocumentLayout title="Termos de Uso" updatedAt="15 de junho de 2026">
      <p>
        Estes Termos de Uso (“Termos”) regulam o acesso e a utilização da plataforma{" "}
        <strong>XPro</strong>, operada pela <strong>Xvision Tecnologia</strong> (“Xvision”), por
        meio de <strong>xpro4.xpro.me</strong> e demais domínios autorizados (“Plataforma”).
      </p>
      <p>
        Ao criar conta, acessar ou utilizar a Plataforma, você (“Usuário”) concorda com estes Termos.
        Se não concordar, não utilize o serviço.
      </p>

      <h2>1. Objeto</h2>
      <p>
        O XPro é uma solução de software como serviço (SaaS) para gestão de atendimento, relacionamento
        com clientes, operações de equipe, automações, integrações de canais e funcionalidades
        correlatas, conforme o plano e permissões do workspace contratado.
      </p>

      <h2>2. Cadastro e conta</h2>
      <ul>
        <li>Você deve fornecer informações verdadeiras, completas e atualizadas.</li>
        <li>
          É responsável pela confidencialidade de suas credenciais e por todas as atividades
          realizadas em sua conta.
        </li>
        <li>
          Administradores do workspace podem gerenciar usuários, permissões e configurações conforme
          o perfil de acesso.
        </li>
        <li>
          A Xvision pode suspender ou encerrar contas em caso de violação destes Termos, risco de
          segurança ou exigência legal.
        </li>
      </ul>

      <h2>3. Uso aceitável</h2>
      <p>É vedado utilizar a Plataforma para:</p>
      <ul>
        <li>Violar leis, regulamentos ou direitos de terceiros.</li>
        <li>Enviar spam, conteúdo ilícito, difamatório, fraudulento ou malicioso.</li>
        <li>Tentar acessar áreas, dados ou contas sem autorização.</li>
        <li>Realizar engenharia reversa, sobrecarga ou interferência indevida nos sistemas.</li>
        <li>Utilizar a Plataforma de forma que prejudique sua estabilidade ou a de outros clientes.</li>
      </ul>

      <h2>4. Conteúdo e dados do Usuário</h2>
      <p>
        O Usuário e/ou o titular do workspace mantêm a titularidade sobre os dados e conteúdos inseridos
        na Plataforma. A Xvision recebe licença limitada para hospedar, processar, exibir e transmitir
        tais dados exclusivamente para prestar o serviço, cumprir obrigações legais e executar
        integrações autorizadas.
      </p>
      <p>
        O Usuário declara possuir base legal para tratar dados pessoais de terceiros inseridos na
        Plataforma, incluindo clientes e contatos, em conformidade com a LGPD.
      </p>

      <h2>5. Integrações de terceiros</h2>
      <p>
        A Plataforma pode oferecer integrações opcionais (por exemplo, Google Agenda, WhatsApp, Meta,
        telefonia e outras). Ao ativá-las:
      </p>
      <ul>
        <li>Você autoriza a troca de dados necessária ao funcionamento da integração.</li>
        <li>
          O uso também se sujeita aos termos e políticas do provedor terceiro (ex.: Google).
        </li>
        <li>
          Recursos, limites e disponibilidade podem variar conforme APIs e políticas de terceiros.
        </li>
        <li>
          A Xvision não se responsabiliza por indisponibilidades, alterações ou encerramento de serviços
          de terceiros fora de seu controle.
        </li>
      </ul>

      <h2>6. Planos, cobrança e trial</h2>
      <p>
        Funcionalidades, limites de uso e valores dependem do plano contratado. Cobranças recorrentes,
        upgrades, cancelamentos e reembolsos seguem as condições comerciais aplicáveis ao workspace e
        comunicadas no momento da contratação ou no painel administrativo.
      </p>

      <h2>7. Disponibilidade e suporte</h2>
      <p>
        Buscamos alta disponibilidade, mas não garantimos operação ininterrupta ou livre de erros.
        Manutenções programadas ou emergenciais podem ocorrer. O suporte é prestado pelos canais
        indicados pela Xvision ou pelo representante comercial responsável pelo workspace.
      </p>

      <h2>8. Propriedade intelectual</h2>
      <p>
        A Plataforma, sua marca, código, layout, documentação e demais elementos da Xvision são
        protegidos por direitos de propriedade intelectual. Estes Termos não concedem qualquer
        direito de propriedade sobre a Plataforma, exceto o direito limitado de uso conforme aqui
        previsto.
      </p>

      <h2>9. Confidencialidade e segurança</h2>
      <p>
        A Xvision adota medidas razoáveis de segurança da informação. O Usuário deve adotar boas
        práticas (senhas fortes, controle de acessos internos, revisão periódica de permissões).
      </p>

      <h2>10. Limitação de responsabilidade</h2>
      <p>
        Na extensão permitida pela lei aplicável, a Xvision não responde por lucros cessantes, perda
        de dados causada por uso inadequado, decisões de negócio tomadas com base em informações da
        Plataforma ou danos indiretos. A responsabilidade total da Xvision, quando cabível, limita-se
        ao montante pago pelo workspace nos últimos 12 (doze) meses anteriores ao evento, salvo
        disposição legal em contrário.
      </p>

      <h2>11. Privacidade</h2>
      <p>
        O tratamento de dados pessoais é regido pela{" "}
        <a href="/privacy">Política de Privacidade</a> do XPro, parte integrante destes Termos.
      </p>

      <h2>12. Alterações</h2>
      <p>
        Podemos alterar estes Termos a qualquer tempo. A versão vigente será publicada nesta página
        com a data de atualização. O uso continuado após alterações relevantes constitui aceitação,
        salvo quando a lei exigir consentimento específico.
      </p>

      <h2>13. Rescisão</h2>
      <p>
        O Usuário pode deixar de utilizar a Plataforma conforme procedimentos de cancelamento
        aplicáveis. A Xvision pode encerrar ou suspender o acesso por violação destes Termos,
        inadimplência ou determinação legal, observados prazos de exportação ou backup quando
        previstos contratualmente.
      </p>

      <h2>14. Lei aplicável e foro</h2>
      <p>
        Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da
        comarca de Goiânia/GO, com renúncia a qualquer outro, por mais privilegiado que seja, salvo
        hipóteses de competência legal absoluta.
      </p>

      <h2>15. Contato</h2>
      <p>
        Xvision Tecnologia — Plataforma XPro
        <br />
        E-mail: <a href="mailto:contato@xpro.me">contato@xpro.me</a>
        <br />
        Site institucional:{" "}
        <a href="https://xvisiontecnologia.com.br">https://xvisiontecnologia.com.br</a>
        <br />
        Aplicação XPro: <a href="https://xpro4.xpro.me">https://xpro4.xpro.me</a>
      </p>
    </LegalDocumentLayout>
  );
}
